<button type="button" class="widget-settings-btn" data-testid="widget-settings-btn" aria-label="Settings" (click)="openSettings()">
  <img [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/settings_icon.svg'" alt="settings" />
</button>
